import { render, staticRenderFns } from "./exhibition-control-brandInt.vue?vue&type=template&id=3156c8de&scoped=true&"
import script from "./exhibition-control-brandInt.vue?vue&type=script&lang=js&"
export * from "./exhibition-control-brandInt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3156c8de",
  null
  
)

export default component.exports